import AssetsInfoTabs from "./AssetsInfoTabs";
import FlowsInfoTabs from "./FlowsInfoTab";
import ThreatsInfoTabs from "./ThreatsInfoTabs";

const ThreatModelingTabs = [...AssetsInfoTabs, ...FlowsInfoTabs, ...ThreatsInfoTabs];

export default ThreatModelingTabs;
